@if (slides) {
  <ngb-carousel #carousel class="carousel">
    @for (slide of slides; track slide) {
      <ng-template ngbSlide>
        <div class="picsum-img-wrapper">
          @if (slide) {
            <wagtail-page-element-image
              [image]="slide"
            ></wagtail-page-element-image>
          }
        </div>
      </ng-template>
    }
  </ngb-carousel>
}